import axios from "axios";
import { getAuth } from "../providers/AppAuthProvider";

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = "smart-money"

export async function findSmartMoneyMetadata(address: string, chainId: number) {
  const url = `${baseUrl}/${resource}/${address}:${chainId}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.get<any>(
    url,
    {
      headers,
    }
  );
}
export async function uploadCSVFile(formData: FormData) {
  const url = `${baseUrl}/${resource}/upload`;

  const { accessToken } = (await getAuth()) || {};

  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    // 'Content-Type': 'multipart/form-data',
  };

  return axios.post<any>(url, formData, { headers });
}